import React, { PropsWithChildren, useEffect } from 'react';
import { useInjection } from '@cp/shared/di';
import { useClientProfile } from 'src/entities/client';
import { SPIDER_SERVICE_TOKEN } from './const';

export const TrackingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const spiderService = useInjection(SPIDER_SERVICE_TOKEN);
  const clientProfile = useClientProfile();

  useEffect(() => {
    if (!clientProfile) {
      return;
    }
    spiderService.updateContext({ client: { client_id: clientProfile.id, client_type: Number(clientProfile.type) } });
  }, [clientProfile, spiderService]);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
